import React, { lazy, Suspense, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import StaticPage from 'src/components/StaticPage/StaticPage'
import { SupportedBrands } from 'src/enums'
import {
  selectAppName,
  selectBrandName,
  selectExternalSupportUrl,
} from 'src/redux/selectors/session.selectors'
import { useWhitelabel } from 'src/utils/whitelabel.utils'

const Support: React.FC = () => {
  const brandName = useSelector(selectBrandName)
  const { whiteLabelIncludes } = useWhitelabel()
  const externalSupportUrl = useSelector(selectExternalSupportUrl)
  const appName = useSelector(selectAppName)

  const isJpm = whiteLabelIncludes(SupportedBrands.Jpm)

  const SupportComponent = useMemo(
    () =>
      externalSupportUrl === undefined
        ? lazy(() => import(`src/branded/${brandName}/Support/Support`))
        : (): null => {
            window.location.href = externalSupportUrl
            return null
          },
    [brandName],
  )

  const content = (
    <>
      <Helmet>
        <title>{`${appName}`}</title>
        <meta
          name="description"
          content={`Log into ${appName} to create, send, and manage virtual cards for all your business payments.`}
        />
      </Helmet>
      <Suspense fallback={<LoadingBackgroundPage />}>
        <SupportComponent />
      </Suspense>
    </>
  )

  return isJpm ? content : <StaticPage>{content}</StaticPage>
}

export default Support
